import { addToCartButton } from "./add-to-cart-button";
import { cartInstallments } from "./cart-installments";
import { cartItemQuantity } from "./cart-item-quantity";
import { productDetailCompareAtPrice } from "./product-detail-compare-at-price";
import { productDetailInstallments } from "./product-detail-installments";
import { productDetailPrice } from "./product-detail-price";
import { productDetailQuantity } from "./product-detail-quantity";
import { productDetailVariants } from "./product-detail-variants";
import { productGridInstallments } from "./product-grid-installments";
import { productGridItemCompareAtPrice } from "./product-grid-item-compare-at-price";
import { productGridItemPrice } from "./product-grid-item-price";
import type { CustomizationHandlerMap, ErasedHandler } from "./types";

// `CustomizationHandlerMap` stays internal: it only exists to type the catalog.
export type { CustomizationHandler, ErasedHandler } from "./types";

/**
 * The global, fixed catalog: one entry per file, so this list stays a table of
 * contents. The `CustomizationHandlerMap` annotation is what makes a missing
 * entry a compile error.
 *
 * @see ./README.md
 */
export const CUSTOMIZATION_HANDLERS: CustomizationHandlerMap = {
	"add-to-cart-button": addToCartButton,
	"product-detail-installments": productDetailInstallments,
	"product-grid-installments": productGridInstallments,
	"product-detail-price": productDetailPrice,
	"product-grid-item-price": productGridItemPrice,
	"product-detail-compare-at-price": productDetailCompareAtPrice,
	"product-grid-item-compare-at-price": productGridItemCompareAtPrice,
	"cart-installments": cartInstallments,
	"product-detail-quantity": productDetailQuantity,
	"cart-item-quantity": cartItemQuantity,
	"product-detail-variants": productDetailVariants,
};

// The single point where the catalog's precise typing is erased. Authoring
// stays fully checked against `CustomizationHandlerMap` above.
const ERASED = CUSTOMIZATION_HANDLERS as unknown as Record<
	string,
	ErasedHandler | undefined
>;

/**
 * Look up a target coming from an app. The own-key guard matters: targets
 * arrive as arbitrary strings, and a plain index would happily resolve
 * inherited keys such as `"toString"`.
 */
export function getHandler(target: string): ErasedHandler | undefined {
	if (!Object.prototype.hasOwnProperty.call(CUSTOMIZATION_HANDLERS, target)) {
		return undefined;
	}
	return ERASED[target];
}
